var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CreativeOverview',{attrs:{"headline-name":"Native Creatives","edit-route":_vm.editRoute,"headers":_vm.headers,"service-domain":_vm.serviceDomain}},[_c('div',{attrs:{"slot":"header-actions"},slot:"header-actions"},[_c('SrButton',{attrs:{"type":"secondary"},on:{"click":_vm.openCreateForm}},[_vm._v("Create")])],1)]),_c('RouterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }